export const albums = [
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'The Spirit of Radio: Greatest Hits (1974-1987)',
		artworkUrl60:
			'https://is3-ssl.mzstatic.com/image/thumb/Music128/v4/84/48/61/844861a1-aea2-9b29-16c7-16e4cef92792/source/60x60bb.jpg',
		artworkUrl100:
			'https://is3-ssl.mzstatic.com/image/thumb/Music128/v4/84/48/61/844861a1-aea2-9b29-16c7-16e4cef92792/source/100x100bb.jpg',
		releaseDate: '2003-02-11T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
			'John Rutsey: drums on "Working Man"',
		],
		trackListing: [
			'Working Man',
			'Fly by Night',
			'2112 Overture/The Temples of Syrinx',
			'Closer to the Heart',
			'The Trees',
			'The Spirit of Radio',
			'Freewill',
			'Limelight',
			'Tom Sawyer',
			'Red Barchetta',
			'New World Man',
			'Subdivisions',
			'Distant Early Warning',
			'The Big Money',
			'Force Ten',
			'Time Stand Still',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Moving Pictures (Remastered)',
		artworkUrl60:
			'https://is4-ssl.mzstatic.com/image/thumb/Music118/v4/f3/bf/48/f3bf4826-4a41-c6c4-e24b-19613a232657/source/60x60bb.jpg',
		artworkUrl100:
			'https://is4-ssl.mzstatic.com/image/thumb/Music118/v4/f3/bf/48/f3bf4826-4a41-c6c4-e24b-19613a232657/source/100x100bb.jpg',
		releaseDate: '1981-02-12T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Tom Sawyer',
			'Red Barchetta',
			'YYZ',
			'Limelight',
			'The Camera Eye',
			'Witch Hunt',
			'Vital Signs',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: '2112 (Remastered)',
		artworkUrl60:
			'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/60/3e/bb/603ebb90-05f6-d08d-ca61-561625e29c36/source/60x60bb.jpg',
		artworkUrl100:
			'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/60/3e/bb/603ebb90-05f6-d08d-ca61-561625e29c36/source/100x100bb.jpg',
		releaseDate: '1976-04-01T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'2112',
			'A Passage to Bangkok',
			'The Twilight Zone',
			'Lessons',
			'Tears',
			'Something for Nothing',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Clockwork Angels',
		artworkUrl60:
			'https://is1-ssl.mzstatic.com/image/thumb/Music/v4/b0/04/5e/b0045e1b-8e87-d123-e8e0-a61c66260c45/source/60x60bb.jpg',
		artworkUrl100:
			'https://is1-ssl.mzstatic.com/image/thumb/Music/v4/b0/04/5e/b0045e1b-8e87-d123-e8e0-a61c66260c45/source/100x100bb.jpg',
		releaseDate: '2012-06-08T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Caravan',
			'BU2B',
			'Clockwork Angels',
			'The Anarchist',
			'Carnies',
			'The Halo Effect',
			'Seven Cities of Gold',
			'The Wreckers',
			'Headlong Flight',
			'BU2B2',
			'Wish Them Well',
			'The Garden',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Permanent Waves (Remastered)',
		artworkUrl60:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/30/7d/e5/307de53c-3026-1204-d2b3-0116f38f4c42/source/60x60bb.jpg',
		artworkUrl100:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/30/7d/e5/307de53c-3026-1204-d2b3-0116f38f4c42/source/100x100bb.jpg',
		releaseDate: '1980-01-14T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'The Spirit of Radio',
			'Freewill',
			"Jacob's Ladder",
			'Entre Nous',
			'Different Strings',
			'Natural Science',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Signals (Remastered)',
		artworkUrl60:
			'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/25/b0/28/25b02823-0b4e-b13f-362a-379f490cfbdc/source/60x60bb.jpg',
		artworkUrl100:
			'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/25/b0/28/25b02823-0b4e-b13f-362a-379f490cfbdc/source/100x100bb.jpg',
		releaseDate: '1982-09-09T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Subdivisions',
			'The Analog Kid',
			'Chemistry',
			'Digital Man',
			'The Weapon',
			'New World Man',
			'Losing It',
			'Countdown',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Rush (Remastered)',
		artworkUrl60:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/20/89/ff/2089ffad-bdda-c2d8-05ba-aca87072a321/source/60x60bb.jpg',
		artworkUrl100:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/20/89/ff/2089ffad-bdda-c2d8-05ba-aca87072a321/source/100x100bb.jpg',
		releaseDate: '1974-03-01T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'John Rutsey: drums',
		],
		trackListing: [
			'Finding My Way',
			'Need Some Love',
			'Take a Friend',
			'Here Again',
			"What You're Doing",
			'In the Mood',
			'Before and After',
			'Working Man',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Fly By Night (Remastered)',
		artworkUrl60:
			'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/35/2b/22/352b222d-ae64-dd65-ade0-ff0434360ccb/source/60x60bb.jpg',
		artworkUrl100:
			'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/35/2b/22/352b222d-ae64-dd65-ade0-ff0434360ccb/source/100x100bb.jpg',
		releaseDate: '1975-02-15T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Anthem',
			'Best I Can',
			'Beneath, Between & Behind',
			'By-Tor & the Snow Dog',
			'Fly by Night',
			'Making Memories',
			'Rivendell',
			'In the End',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Snakes & Arrows',
		artworkUrl60:
			'https://is5-ssl.mzstatic.com/image/thumb/Music2/v4/7e/0e/a7/7e0ea7e2-da8d-e62b-589e-bd5221a4e7dd/source/60x60bb.jpg',
		artworkUrl100:
			'https://is5-ssl.mzstatic.com/image/thumb/Music2/v4/7e/0e/a7/7e0ea7e2-da8d-e62b-589e-bd5221a4e7dd/source/100x100bb.jpg',
		releaseDate: '2013-05-10T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Far Cry',
			'Armor and Sword',
			"Workin' Them Angels",
			'The Larger Bowl (A Pantoum)',
			'Spindrift',
			'The Main Monkey Business',
			'The Way the Wind Blows',
			'Hope',
			'Faithless',
			'Bravest Face',
			'Good News First',
			'Malignant Narcissism',
			'We Hold On',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Exit... Stage Left (Live) [Remastered]',
		artworkUrl60:
			'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/7c/7f/11/7c7f11a4-8f32-2fc8-a9bf-0467ddcbbdc1/source/60x60bb.jpg',
		artworkUrl100:
			'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/7c/7f/11/7c7f11a4-8f32-2fc8-a9bf-0467ddcbbdc1/source/100x100bb.jpg',
		releaseDate: '1981-10-29T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'The Spirit of Radio',
			'Red Barchetta',
			'YYZ',
			'A Passage to Bangkok',
			'Closer to the Heart',
			'Beneath, Between & Behind',
			"Jacob's Ladder",
			"Broon's Bane",
			'The Trees',
			'Xanadu',
			'Freewill',
			'Tom Sawyer',
			'La Villa Strangiato',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'A Farewell to Kings (Remastered)',
		artworkUrl60:
			'https://is5-ssl.mzstatic.com/image/thumb/Music128/v4/82/4c/8d/824c8d93-84a0-da1b-1a08-a8238b6431fe/source/60x60bb.jpg',
		artworkUrl100:
			'https://is5-ssl.mzstatic.com/image/thumb/Music128/v4/82/4c/8d/824c8d93-84a0-da1b-1a08-a8238b6431fe/source/100x100bb.jpg',
		releaseDate: '1977-09-01T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'A Farewell to Kings',
			'Xanadu',
			'Closer to the Heart',
			'Cinderella Man',
			'Madrigal',
			'Cygnus X-1 Book I: The Voyage',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Power Windows (Remastered)',
		artworkUrl60:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/f7/b6/49/f7b64924-e671-a7bf-d132-d95f11b5d249/source/60x60bb.jpg',
		artworkUrl100:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/f7/b6/49/f7b64924-e671-a7bf-d132-d95f11b5d249/source/100x100bb.jpg',
		releaseDate: '1985-10-14T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'The Big Money',
			'Grand Designs',
			'Manhattan Project',
			'Marathon',
			'Territories',
			'Middletown Dreams',
			'Emotion Detector',
			'Mystic Rhythms',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Hemispheres (Remastered)',
		artworkUrl60:
			'https://is4-ssl.mzstatic.com/image/thumb/Music118/v4/ab/f8/cb/abf8cb9e-5703-17c8-4fbf-ae4fa90056e0/source/60x60bb.jpg',
		artworkUrl100:
			'https://is4-ssl.mzstatic.com/image/thumb/Music118/v4/ab/f8/cb/abf8cb9e-5703-17c8-4fbf-ae4fa90056e0/source/100x100bb.jpg',
		releaseDate: '1978-10-29T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Cygnus X-1 Book II: Hemispheres',
			'Circumstances',
			'The Trees',
			'La Villa Strangiato (An Exercise in Self-Indulgence)',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Grace Under Pressure (Remastered)',
		artworkUrl60:
			'https://is4-ssl.mzstatic.com/image/thumb/Music118/v4/24/61/2e/24612e4c-118d-81b5-c564-4333f7995448/source/60x60bb.jpg',
		artworkUrl100:
			'https://is4-ssl.mzstatic.com/image/thumb/Music118/v4/24/61/2e/24612e4c-118d-81b5-c564-4333f7995448/source/100x100bb.jpg',
		releaseDate: '1984-04-12T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Distant Early Warning',
			'Afterimage',
			'Red Sector A',
			'The Enemy Within (Part I of Fear)',
			'The Body Electric',
			'Kid Gloves',
			'Red Lenses',
			'Between the Wheels',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Rush In Rio (Live)',
		artworkUrl60:
			'https://is1-ssl.mzstatic.com/image/thumb/Music2/v4/39/8b/99/398b9978-cba0-ecd2-962f-5af174003389/source/60x60bb.jpg',
		artworkUrl100:
			'https://is1-ssl.mzstatic.com/image/thumb/Music2/v4/39/8b/99/398b9978-cba0-ecd2-962f-5af174003389/source/100x100bb.jpg',
		releaseDate: '2004-01-27T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Tom Sawyer',
			'Distant Early Warning',
			'New World Man',
			'Roll the Bones',
			'Earthshine',
			'YYZ',
			'The Pass',
			'Bravado',
			'The Big Money',
			'The Trees',
			'Freewill',
			'Closer to the Heart',
			'Natural Science',
			'One Little Victory',
			'Driven',
			'Ghost Rider',
			'Secret Touch',
			'Dreamline',
			'Red Sector A',
			'Leave That Thing Alone',
			'O Baterista',
			'Resist',
			'2112 Overture/The Temples of Syrinx',
			'Limelight',
			'La Villa Strangiato',
			'The Spirit of Radio',
			'By-Tor & the Snow Dog',
			'Cygnus X-1',
			'Working Man',
			'Between Sun & Moon',
			'Vital Signs',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Roll the Bones (Remastered)',
		artworkUrl60:
			'https://is4-ssl.mzstatic.com/image/thumb/Music/v4/a7/52/d8/a752d88d-3f6f-a6f1-9d0b-0f30eb7f6cf4/source/60x60bb.jpg',
		artworkUrl100:
			'https://is4-ssl.mzstatic.com/image/thumb/Music/v4/a7/52/d8/a752d88d-3f6f-a6f1-9d0b-0f30eb7f6cf4/source/100x100bb.jpg',
		releaseDate: '2013-05-10T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Dreamline',
			'Bravado',
			'Roll the Bones',
			'Face Up',
			"Where's My Thing? (Part IV, Gangsters of Boats Trilogy)",
			'The Big Wheel',
			'Heresy',
			'Ghost of a Chance',
			'Neurotica',
			'You Bet Your Life',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Vapor Trails (Remixed)',
		artworkUrl60:
			'https://is2-ssl.mzstatic.com/image/thumb/Music4/v4/87/bf/94/87bf9419-787a-e286-538c-8c8241e9c249/source/60x60bb.jpg',
		artworkUrl100:
			'https://is2-ssl.mzstatic.com/image/thumb/Music4/v4/87/bf/94/87bf9419-787a-e286-538c-8c8241e9c249/source/100x100bb.jpg',
		releaseDate: '2013-09-27T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'One Little Victory',
			'Ceiling Unlimited',
			'Ghost Rider',
			'Peaceable Kingdom',
			'The Stars Look Down',
			'How It Is',
			'Vapor Trail',
			'Secret Touch',
			'Earthshine',
			'Sweet Miracle',
			'Nocturne',
			'Freeze (Part IV of Fear)',
			'Out of the Cradle',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Gold: Rush',
		artworkUrl60:
			'https://is2-ssl.mzstatic.com/image/thumb/Music113/v4/17/de/a4/17dea4be-4cdc-6032-78f0-7ea6e19a6c4a/source/60x60bb.jpg',
		artworkUrl100:
			'https://is2-ssl.mzstatic.com/image/thumb/Music113/v4/17/de/a4/17dea4be-4cdc-6032-78f0-7ea6e19a6c4a/source/100x100bb.jpg',
		releaseDate: '2006-04-25T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'The Spirit of Radio',
			'The Trees',
			'Freewill',
			'Xanadu',
			'Bastille Day',
			'By-Tor and the Snow Dog',
			'Anthem',
			'Closer to the Heart',
			'2112: Overture',
			'2112: The Temples of Syrinx',
			'La Villa Strangiato',
			'Fly by Night',
			'Finding My Way',
			'Working Man',
			'The Big Money',
			'Red Barchetta',
			'Subdivisions',
			'Time Stand Still',
			'Mystic Rhythms',
			'The Analog Kid',
			'Distant Early Warning',
			'Marathon',
			'The Body Electric',
			'Mission',
			'Limelight',
			'Red Sector A',
			'New World Man',
			'Tom Sawyer',
			'Force Ten',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Caress of Steel (Remastered)',
		artworkUrl60:
			'https://is3-ssl.mzstatic.com/image/thumb/Music128/v4/a0/0a/19/a00a19af-05f8-1e15-7a31-782f8918f338/source/60x60bb.jpg',
		artworkUrl100:
			'https://is3-ssl.mzstatic.com/image/thumb/Music128/v4/a0/0a/19/a00a19af-05f8-1e15-7a31-782f8918f338/source/100x100bb.jpg',
		releaseDate: '1975-09-24T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Bastille Day',
			"I Think I'm Going Bald",
			'Lakeside Park',
			'The Necromancer',
			'The Fountain of Lamneth',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Counterparts (Remastered)',
		artworkUrl60:
			'https://is2-ssl.mzstatic.com/image/thumb/Music/v4/80/23/76/802376d8-39cb-dc58-89ec-59193060b328/source/60x60bb.jpg',
		artworkUrl100:
			'https://is2-ssl.mzstatic.com/image/thumb/Music/v4/80/23/76/802376d8-39cb-dc58-89ec-59193060b328/source/100x100bb.jpg',
		releaseDate: '2013-05-10T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Animate',
			'Stick It Out',
			'Cut to the Chase',
			"Nobody's Hero",
			'Between Sun & Moon',
			'Alien Shore',
			'The Speed of Love',
			'Double Agent',
			'Leave That Thing Alone',
			'Cold Fire',
			'Everyday Glory',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Hold Your Fire (Remastered)',
		artworkUrl60:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/21/b0/e6/21b0e614-bd67-40cb-54ca-47ab23bdb8b0/source/60x60bb.jpg',
		artworkUrl100:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/21/b0/e6/21b0e614-bd67-40cb-54ca-47ab23bdb8b0/source/100x100bb.jpg',
		releaseDate: '1987-09-03T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Force Ten',
			'Time Stand Still',
			'Open Secrets',
			'Second Nature',
			'Prime Mover',
			'Lock and Key',
			'Mission',
			'Turn the Page',
			'Tai Shan',
			'High Water',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Clockwork Angels Tour (Live)',
		artworkUrl60:
			'https://is4-ssl.mzstatic.com/image/thumb/Music6/v4/f7/dc/03/f7dc03ce-deea-3b41-c509-6560ebe3a4ae/source/60x60bb.jpg',
		artworkUrl100:
			'https://is4-ssl.mzstatic.com/image/thumb/Music6/v4/f7/dc/03/f7dc03ce-deea-3b41-c509-6560ebe3a4ae/source/100x100bb.jpg',
		releaseDate: '2013-11-05T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Subdivisions',
			'The Big Money',
			'Force Ten',
			'Grand Designs',
			'The Body Electric',
			'Territories',
			'The Analog Kid',
			'Bravado',
			"Where's My Thing?/Here It Is! (drum solo)",
			'Far Cry',
			'Caravan',
			'Clockwork Angels',
			'The Anarchist',
			'Carnies',
			'The Wreckers',
			'Headlong Flight/Drumbastica (drum solo)',
			"Peke's Repose (guitar solo)/Halo Effect",
			'Seven Cities of Gold',
			'Wish Them Well',
			'The Garden',
			'Dreamline',
			"The Percussor (I) Binary Love Theme (II) Steanburger's Ball (drum solo)",
			'Red Sector A',
			'YYZ',
			'The Spirit of Radio',
			'Tom Sawyer',
			'2112: Overture/The Temples of Syrinx/Grand Finale',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Presto (Remastered)',
		artworkUrl60:
			'https://is3-ssl.mzstatic.com/image/thumb/Music/v4/bc/aa/38/bcaa389d-7543-d203-d469-18232095287a/source/60x60bb.jpg',
		artworkUrl100:
			'https://is3-ssl.mzstatic.com/image/thumb/Music/v4/bc/aa/38/bcaa389d-7543-d203-d469-18232095287a/source/100x100bb.jpg',
		releaseDate: '2013-05-10T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			"Show Don't Tell",
			'Chain Lightning',
			'The Pass',
			'War Paint',
			'Scars',
			'Presto',
			'Superconductor',
			'Anagram (For Mongo)',
			'Red Tide',
			'Hand Over Fist',
			'Available Light',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Time Machine 2011: Live In Cleveland',
		artworkUrl60:
			'https://is1-ssl.mzstatic.com/image/thumb/Music/v4/2e/fd/25/2efd25db-b167-da4a-582f-33a85b876b3f/source/60x60bb.jpg',
		artworkUrl100:
			'https://is1-ssl.mzstatic.com/image/thumb/Music/v4/2e/fd/25/2efd25db-b167-da4a-582f-33a85b876b3f/source/100x100bb.jpg',
		releaseDate: '2011-11-04T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'The Spirit of Radio',
			'Time Stand Still',
			'Presto',
			'Stick It Out',
			"Workin' Them Angels",
			'Leave That Thing Alone',
			'Faithless',
			'BU2B',
			'Freewill',
			'Marathon',
			'Subdivisions',
			'Tom Sawyer',
			'Red Barchetta',
			'YYZ',
			'Limelight',
			'The Camera Eye',
			'Witch Hunt',
			'Vital Signs',
			'Caravan',
			'Moto Perpetuo/Love for Sale (Drum Solo)',
			"O'Malley's Break (Acoustic Solo)",
			'Closer to the Heart',
			'2112 Overture/The Temples of Syrinx',
			'Far Cry',
			'La Villa Strangiato',
			'Working Man (half reggae version)',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: "All the World's a Stage (Live) [Remastered]",
		artworkUrl60:
			'https://is4-ssl.mzstatic.com/image/thumb/Music118/v4/1b/ca/9b/1bca9b97-68a2-b7ad-6b9e-0156d87671c1/source/60x60bb.jpg',
		artworkUrl100:
			'https://is4-ssl.mzstatic.com/image/thumb/Music118/v4/1b/ca/9b/1bca9b97-68a2-b7ad-6b9e-0156d87671c1/source/100x100bb.jpg',
		releaseDate: '1976-09-29T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Bastille Day',
			'Anthem',
			'Fly by Night/In the Mood',
			'Something For Nothing',
			'Lakeside Park',
			'2112',
			'By-Tor and the Snow Dog',
			'In the End',
			'Working Man/Finding My Way',
			"What You're Doing",
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Snakes & Arrows: Live',
		artworkUrl60:
			'https://is3-ssl.mzstatic.com/image/thumb/Music/v4/74/29/1c/74291ca6-2e66-f009-04ef-4d094b81b790/source/60x60bb.jpg',
		artworkUrl100:
			'https://is3-ssl.mzstatic.com/image/thumb/Music/v4/74/29/1c/74291ca6-2e66-f009-04ef-4d094b81b790/source/100x100bb.jpg',
		releaseDate: '2008-04-12T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Limelight',
			'Digital Man',
			'Entre Nous',
			'Mission',
			'Freewill',
			'The Main Monkey Business',
			'The Larger Bowl',
			'Secret Touch',
			'Circumstances',
			'Between the Wheels',
			'Dreamline',
			'Far Cry',
			"Workin' Them Angels",
			'Armor and Sword',
			'Spindrift',
			'The Way the Wind Blows',
			'Subdivisions',
			'Natural Science',
			'Witch Hunt',
			'Malignant Narcissism – De Slagwerker (Drum Solo)',
			'Hope',
			'Distant Early Warning',
			'The Spirit of Radio',
			'Tom Sawyer',
			'One Little Victory',
			'A Passage to Bangkok',
			'YYZ',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Test for Echo',
		artworkUrl60:
			'https://is3-ssl.mzstatic.com/image/thumb/Music2/v4/9c/fc/ce/9cfcce23-aaac-538c-5c82-33374c75392e/source/60x60bb.jpg',
		artworkUrl100:
			'https://is3-ssl.mzstatic.com/image/thumb/Music2/v4/9c/fc/ce/9cfcce23-aaac-538c-5c82-33374c75392e/source/100x100bb.jpg',
		releaseDate: '2013-05-10T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Test for Echo',
			'Driven',
			'Half the World',
			'The Color of Right',
			'Time and Motion',
			'Totem',
			'Dog Years',
			'Virtuality',
			'Resist',
			'Limbo',
			'Carve Away the Stone',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'R30 (Live)',
		artworkUrl60:
			'https://is5-ssl.mzstatic.com/image/thumb/Music/v4/67/4c/19/674c1974-628d-9696-a44e-978ca5620f5d/source/60x60bb.jpg',
		artworkUrl100:
			'https://is5-ssl.mzstatic.com/image/thumb/Music/v4/67/4c/19/674c1974-628d-9696-a44e-978ca5620f5d/source/100x100bb.jpg',
		releaseDate: '2005-11-18T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'R30 Overture - (Finding My Way/Anthem/Bastille Day/A Passage to Bangkok/Cygnus X-1 Book I: The Voyage, Book II: Hemispheres)',
			'The Spirit of Radio',
			'Force Ten',
			'Animate',
			'Subdivisions',
			'Earthshine',
			'Red Barchetta',
			'Roll the Bones',
			'The Seeker',
			'Tom Sawyer',
			'Dreamline',
			'Between the Wheels',
			'Mystic Rhythms',
			'Der Trommler',
			'Resist (the acoustic arrangement first heard on Rush in Rio)',
			'Heart Full of Soul',
			'2112 (Overture/Temples of Syrinx/Grand Finale)',
			'Xanadu (abbreviated version)',
			'Working Man',
			'Summertime Blues',
			'Crossroads',
			'Limelight',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'A Show of Hands (Live) [Remastered]',
		artworkUrl60:
			'https://is3-ssl.mzstatic.com/image/thumb/Music128/v4/b4/8c/b2/b48cb211-3f7a-5cbf-54a4-7b148d2af61b/source/60x60bb.jpg',
		artworkUrl100:
			'https://is3-ssl.mzstatic.com/image/thumb/Music128/v4/b4/8c/b2/b48cb211-3f7a-5cbf-54a4-7b148d2af61b/source/100x100bb.jpg',
		releaseDate: '1989-01-01T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Intro',
			'The Big Money (Birmingham, UK)',
			'Subdivisions (Birmingham, UK)',
			'Marathon (Birmingham, UK)',
			'Turn the Page (New Orleans, LA)',
			'Manhattan Project (Phoenix, AZ)',
			'Mission (San Diego, CA)',
			'Distant Early Warning (Birmingham, UK)',
			'Mystic Rhythms (Meadowlands, NJ)',
			'Witch Hunt (Part III of Fear) (Meadowlands, NJ)',
			'The Rhythm Method (Drum Solo) (Birmingham, UK)',
			'Force Ten (Lifeson, Lee, Peart, Pye Dubois) (Phoenix, AZ)',
			'Time Stand Still (Birmingham, UK)',
			'Red Sector A (Birmingham, UK)',
			'Closer to the Heart',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Different Stages • Live',
		artworkUrl60:
			'https://is5-ssl.mzstatic.com/image/thumb/Music/v4/ed/20/01/ed200157-d89e-8fc2-8e86-246967a3d82d/source/60x60bb.jpg',
		artworkUrl100:
			'https://is5-ssl.mzstatic.com/image/thumb/Music/v4/ed/20/01/ed200157-d89e-8fc2-8e86-246967a3d82d/source/100x100bb.jpg',
		releaseDate: '1998-11-10T08:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Dreamline',
			'Limelight',
			'Driven',
			'Bravado (recorded on April 30, 1994 at the Spectrum in Philadelphia)',
			'Animate (recorded on June 23, 1997 at Great Woods Center for the Performing Arts in Mansfield, Massachusetts)',
			"Show Don't Tell (recorded on February 27, 1994 at the Miami Arena)",
			'The Trees (recorded on May 24, 1997 at the Coca-Cola Starplex Amphitheatre in Dallas)',
			"Nobody's Hero",
			'Closer to the Heart (Lifeson, Lee, Peart, Peter Talbot)',
			'2112: Overture',
			'2112: The Temples of Syrinx',
			'2112: Discovery',
			'2112: Presentation',
			'2112: Oracle: The Dream',
			'2112: Soliloquy',
			'2112: Grand Finale',
			'Test for Echo',
			'The Analog Kid',
			'Freewill',
			'Roll the Bones',
			'Stick It Out',
			'Resist',
			'Leave That Thing Alone',
			'The Rhythm Method (Instrumental) – 1997',
			'Natural Science',
			'Force Ten',
			'The Spirit of Radio',
			'Tom Sawyer',
			'YYZ',
			'Bastille Day',
			'By-Tor & the Snow Dog',
			'Xanadu',
			'A Farewell to Kings',
			'Something for Nothing',
			'Cygnus X-1',
			'Anthem',
			'Working Man',
			'Fly by Night',
			'In the Mood',
			'Cinderella Man',
		],
	},
	{
		wrapperType: 'collection',
		collectionType: 'Album',
		artistName: 'Rush',
		collectionName: 'Grace Under Pressure: 1984 Tour (Live)',
		artworkUrl60:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/f4/ee/e7/f4eee7c0-af3b-8b9b-e2d1-8b59d89be4d2/source/60x60bb.jpg',
		artworkUrl100:
			'https://is2-ssl.mzstatic.com/image/thumb/Music118/v4/f4/ee/e7/f4eee7c0-af3b-8b9b-e2d1-8b59d89be4d2/source/100x100bb.jpg',
		releaseDate: '2006-06-13T07:00:00Z',
		primaryGenreName: 'Rock',
		personnel: [
			'Geddy Lee: bass, vocals',
			'Alex Lifeson: guitar',
			'Neil Peart: drums',
		],
		trackListing: [
			'Intro',
			'The Spirit of Radio',
			'The Enemy Within',
			'The Weapon',
			'Witch Hunt',
			'New World Man',
			'Distant Early Warning',
			'Red Sector A',
			'Closer to the Heart',
			'YYZ/2112: The Temples of Syrinx/Tom Sawyer',
			'Vital Signs',
			'Finding My Way/In the Mood',
		],
	},
];
